import type { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './MenuIcon.less';

interface MenuIconProps {
  isOpen: boolean;
}

export const MenuIcon: FunctionComponent<MenuIconProps> = ({ isOpen }) => (
  <div className={classNames(styles.menuIcon, { [styles.isOpen]: isOpen })}>
    <span></span>
    <span></span>
    <span></span>
  </div>
);
